import { render, staticRenderFns } from "./AllWorkouts.vue?vue&type=template&id=daab2008&scoped=true&"
import script from "./AllWorkouts.vue?vue&type=script&lang=js&"
export * from "./AllWorkouts.vue?vue&type=script&lang=js&"
import style0 from "./AllWorkouts.vue?vue&type=style&index=0&id=daab2008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daab2008",
  null
  
)

export default component.exports